/* oxlint-disable */

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** DateTime with timezone, in ISO format (e.g. 2023-05-22T15:30:00+02:00) */
  DateTime: { input: string; output: string; }
};

export type OrderAppAddress = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  cityArea: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  country: OrderAppCountryDisplay;
  countryArea: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  streetAddress1: Scalars['String']['output'];
  streetAddress2: Scalars['String']['output'];
};

export type OrderAppAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  cityArea?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<OrderAppCountryCode>;
  countryArea?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Array<OrderAppMetadataInput>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  skipValidation?: InputMaybe<Scalars['Boolean']['input']>;
  streetAddress1?: InputMaybe<Scalars['String']['input']>;
  streetAddress2?: InputMaybe<Scalars['String']['input']>;
};

export type OrderAppAttribute = {
  __typename?: 'Attribute';
  slug: Maybe<Scalars['String']['output']>;
};

export type OrderAppAttributeValue = {
  __typename?: 'AttributeValue';
  name: Maybe<Scalars['String']['output']>;
  translation: Maybe<OrderAppAttributeValueTranslation>;
};


export type OrderAppAttributeValueTranslationArgs = {
  languageCode: OrderAppLanguageCodeEnum;
};

export type OrderAppAttributeValueTranslation = {
  __typename?: 'AttributeValueTranslation';
  name: Maybe<Scalars['String']['output']>;
};

export type OrderAppBillingCountry = {
  __typename?: 'BillingCountry';
  code: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type OrderAppCtaType =
  | 'NOTIFY'
  | 'NO_CTA'
  | 'ORDER'
  | 'PRE_ORDER';

export type OrderAppCategory = {
  __typename?: 'Category';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OrderAppChannel = {
  __typename?: 'Channel';
  currencyCode: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
};

export type OrderAppChannelConfig = {
  __typename?: 'ChannelConfig';
  defaultDeliveryMethod: Maybe<Scalars['ID']['output']>;
  deliveryModes: Array<OrderAppDeliveryMode>;
};

export type OrderAppCheckout = {
  __typename?: 'Checkout';
  billingAddress: Maybe<OrderAppAddress>;
  channel: OrderAppChannel;
  deliveryMethod: Maybe<OrderAppDeliveryMethod>;
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  languageCode: Maybe<Scalars['String']['output']>;
  lines: Maybe<Array<OrderAppCheckoutLine>>;
  shippingAddress: Maybe<OrderAppAddress>;
  user: Maybe<OrderAppUser>;
};

export type OrderAppCheckoutAddressValidationRules = {
  checkFieldsFormat?: InputMaybe<Scalars['Boolean']['input']>;
  checkRequiredFields?: InputMaybe<Scalars['Boolean']['input']>;
  enableFieldsNormalization?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderAppCheckoutCreate = {
  __typename?: 'CheckoutCreate';
  checkout: Maybe<OrderAppCheckoutCreateCheckout>;
  errors: Array<OrderAppError>;
};

export type OrderAppCheckoutCreateCheckout = {
  __typename?: 'CheckoutCreateCheckout';
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  user: Maybe<OrderAppCheckoutCreateUser>;
};

export type OrderAppCheckoutCreateInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export type OrderAppCheckoutCreateUser = {
  __typename?: 'CheckoutCreateUser';
  email: Maybe<Scalars['String']['output']>;
};

export type OrderAppCheckoutGwpInput = {
  doNotNeedGift: Scalars['Boolean']['input'];
  gwpProductId: Scalars['String']['input'];
  lineIdToRemove: Scalars['String']['input'];
};

export type OrderAppCheckoutGwpUpdateResult = {
  __typename?: 'CheckoutGwpUpdateResult';
  errors: Array<OrderAppError>;
};

export type OrderAppCheckoutLine = {
  __typename?: 'CheckoutLine';
  hasWarrantyExtension: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  metadata: Maybe<Array<OrderAppMetadataItem>>;
  quantity: Scalars['Int']['output'];
  requiresShipping: Scalars['Boolean']['output'];
  strapPackReference: Maybe<Scalars['String']['output']>;
  strapReference: Maybe<Scalars['String']['output']>;
  totalPrice: OrderAppTaxedMoney;
  undiscountedUnitPrice: OrderAppTaxedMoney;
  unitPrice: OrderAppTaxedMoney;
  variant: OrderAppProductVariant;
  warrantyExtensionDuration: Maybe<Scalars['String']['output']>;
  warrantyExtensionId: Maybe<Scalars['String']['output']>;
  watchLineId: Maybe<Scalars['String']['output']>;
};

export type OrderAppCheckoutLineInput = {
  forceNewLine?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<OrderAppMetadataInput>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Strap pack input, required if we adding product type of Strap Pack */
  strapPackInput?: InputMaybe<OrderAppStrapPackInput>;
  /** Related strap products inputs */
  strapRelatedProducts?: InputMaybe<OrderAppStrapRelatedProductsInput>;
  variantId: Scalars['ID']['input'];
  /** Checkout line id of watch, required if we adding product type of Warranty */
  watchLineId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrderAppCheckoutLinesAddResult = {
  __typename?: 'CheckoutLinesAddResult';
  errors: Array<OrderAppError>;
};

export type OrderAppCheckoutLinesDeleteResult = {
  __typename?: 'CheckoutLinesDeleteResult';
  errors: Array<OrderAppError>;
};

export type OrderAppCheckoutShippingAddressUpdateResult = {
  __typename?: 'CheckoutShippingAddressUpdateResult';
  errors: Array<OrderAppError>;
};

export type OrderAppCheckoutValidationResult = {
  __typename?: 'CheckoutValidationResult';
  checkoutId: Scalars['ID']['output'];
  errors: Array<OrderAppError>;
  valid: Scalars['Boolean']['output'];
};

export type OrderAppCheckoutVoucherAddResult = {
  __typename?: 'CheckoutVoucherAddResult';
  checkout: Maybe<OrderAppCheckout>;
  errors: Array<OrderAppError>;
};

export type OrderAppCheckoutVoucherDeleteResult = {
  __typename?: 'CheckoutVoucherDeleteResult';
  checkout: Maybe<OrderAppCheckout>;
  errors: Array<OrderAppError>;
};

export type OrderAppCountryChannel = {
  __typename?: 'CountryChannel';
  channel: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type OrderAppCountryCode =
  | 'AD'
  | 'AE'
  | 'AF'
  | 'AG'
  | 'AI'
  | 'AL'
  | 'AM'
  | 'AO'
  | 'AQ'
  | 'AR'
  | 'AS'
  | 'AT'
  | 'AU'
  | 'AW'
  | 'AX'
  | 'AZ'
  | 'BA'
  | 'BB'
  | 'BD'
  | 'BE'
  | 'BF'
  | 'BG'
  | 'BH'
  | 'BI'
  | 'BJ'
  | 'BL'
  | 'BM'
  | 'BN'
  | 'BO'
  | 'BQ'
  | 'BR'
  | 'BS'
  | 'BT'
  | 'BV'
  | 'BW'
  | 'BY'
  | 'BZ'
  | 'CA'
  | 'CC'
  | 'CD'
  | 'CF'
  | 'CG'
  | 'CH'
  | 'CI'
  | 'CK'
  | 'CL'
  | 'CM'
  | 'CN'
  | 'CO'
  | 'CR'
  | 'CU'
  | 'CV'
  | 'CW'
  | 'CX'
  | 'CY'
  | 'CZ'
  | 'DE'
  | 'DJ'
  | 'DK'
  | 'DM'
  | 'DO'
  | 'DZ'
  | 'EC'
  | 'EE'
  | 'EG'
  | 'EH'
  | 'ER'
  | 'ES'
  | 'ET'
  | 'EU'
  | 'FI'
  | 'FJ'
  | 'FK'
  | 'FM'
  | 'FO'
  | 'FR'
  | 'GA'
  | 'GB'
  | 'GD'
  | 'GE'
  | 'GF'
  | 'GG'
  | 'GH'
  | 'GI'
  | 'GL'
  | 'GM'
  | 'GN'
  | 'GP'
  | 'GQ'
  | 'GR'
  | 'GS'
  | 'GT'
  | 'GU'
  | 'GW'
  | 'GY'
  | 'HK'
  | 'HM'
  | 'HN'
  | 'HR'
  | 'HT'
  | 'HU'
  | 'ID'
  | 'IE'
  | 'IL'
  | 'IM'
  | 'IN'
  | 'IO'
  | 'IQ'
  | 'IR'
  | 'IS'
  | 'IT'
  | 'JE'
  | 'JM'
  | 'JO'
  | 'JP'
  | 'KE'
  | 'KG'
  | 'KH'
  | 'KI'
  | 'KM'
  | 'KN'
  | 'KP'
  | 'KR'
  | 'KW'
  | 'KY'
  | 'KZ'
  | 'LA'
  | 'LB'
  | 'LC'
  | 'LI'
  | 'LK'
  | 'LR'
  | 'LS'
  | 'LT'
  | 'LU'
  | 'LV'
  | 'LY'
  | 'MA'
  | 'MC'
  | 'MD'
  | 'ME'
  | 'MF'
  | 'MG'
  | 'MH'
  | 'MK'
  | 'ML'
  | 'MM'
  | 'MN'
  | 'MO'
  | 'MP'
  | 'MQ'
  | 'MR'
  | 'MS'
  | 'MT'
  | 'MU'
  | 'MV'
  | 'MW'
  | 'MX'
  | 'MY'
  | 'MZ'
  | 'NA'
  | 'NC'
  | 'NE'
  | 'NF'
  | 'NG'
  | 'NI'
  | 'NL'
  | 'NO'
  | 'NP'
  | 'NR'
  | 'NU'
  | 'NZ'
  | 'OM'
  | 'PA'
  | 'PE'
  | 'PF'
  | 'PG'
  | 'PH'
  | 'PK'
  | 'PL'
  | 'PM'
  | 'PN'
  | 'PR'
  | 'PS'
  | 'PT'
  | 'PW'
  | 'PY'
  | 'QA'
  | 'RE'
  | 'RO'
  | 'RS'
  | 'RU'
  | 'RW'
  | 'SA'
  | 'SB'
  | 'SC'
  | 'SD'
  | 'SE'
  | 'SG'
  | 'SH'
  | 'SI'
  | 'SJ'
  | 'SK'
  | 'SL'
  | 'SM'
  | 'SN'
  | 'SO'
  | 'SR'
  | 'SS'
  | 'ST'
  | 'SV'
  | 'SX'
  | 'SY'
  | 'SZ'
  | 'TC'
  | 'TD'
  | 'TF'
  | 'TG'
  | 'TH'
  | 'TJ'
  | 'TK'
  | 'TL'
  | 'TM'
  | 'TN'
  | 'TO'
  | 'TR'
  | 'TT'
  | 'TV'
  | 'TW'
  | 'TZ'
  | 'UA'
  | 'UG'
  | 'UM'
  | 'US'
  | 'UY'
  | 'UZ'
  | 'VA'
  | 'VC'
  | 'VE'
  | 'VG'
  | 'VI'
  | 'VN'
  | 'VU'
  | 'WF'
  | 'WS'
  | 'YE'
  | 'YT'
  | 'ZA'
  | 'ZM'
  | 'ZW';

export type OrderAppCountryDisplay = {
  __typename?: 'CountryDisplay';
  code: Scalars['String']['output'];
  country: Scalars['String']['output'];
};

export type OrderAppDeleteMetadata = {
  __typename?: 'DeleteMetadata';
  errors: Array<OrderAppError>;
  item: Maybe<OrderAppObjectWithMetadata>;
};

export type OrderAppDeliveryMethod = {
  __typename?: 'DeliveryMethod';
  id: Scalars['ID']['output'];
  type: Maybe<Scalars['String']['output']>;
};

export type OrderAppDeliveryMode =
  | 'BOUTIQUE_PICKUP'
  | 'HOME_DELIVERY';

export type OrderAppDeliveryModeUpdateResult = {
  __typename?: 'DeliveryModeUpdateResult';
  errors: Array<OrderAppError>;
};

export type OrderAppDisabledReasonCode =
  | 'CUSTOMIZED_GOOD'
  | 'GIFT_ITEM'
  | 'HISTORICAL_CERTIFICATE'
  | 'INVALID_LINE_STATUS'
  | 'INVALID_ORDER_STATUS'
  | 'OUT_OF_EU_SCOPE'
  | 'WINDOW_EXPIRED';

export type OrderAppDiscountValueType =
  | 'FIXED'
  | 'PERCENTAGE';

export type OrderAppDiscountValueTypeEnum =
  | 'FIXED'
  | 'PERCENTAGE';

export type OrderAppDraftOrder = {
  __typename?: 'DraftOrder';
  businessId: Scalars['ID']['output'];
  channel: OrderAppChannel;
  id: Scalars['ID']['output'];
};

export type OrderAppDraftOrderCompleteResult = {
  __typename?: 'DraftOrderCompleteResult';
  errors: Array<OrderAppError>;
  order: Maybe<OrderAppOrder>;
};

export type OrderAppDraftOrderCreateInput = {
  billingAddress?: InputMaybe<OrderAppAddressInput>;
  brand?: InputMaybe<Scalars['String']['input']>;
  channelId: Scalars['ID']['input'];
  shippingAddress?: InputMaybe<OrderAppAddressInput>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

export type OrderAppDraftOrderCreateResult = {
  __typename?: 'DraftOrderCreateResult';
  errors: Array<OrderAppError>;
  order: Maybe<OrderAppDraftOrder>;
};

export type OrderAppDynamicSettingsEnum =
  | 'CAPTURE_FAIL_MAILING_LIST'
  | 'PAY_PER_LINK_TOKEN_TIME_TO_LIVE';

/** The value field has to be a json converted to a string */
export type OrderAppEditSettingInput = {
  name: OrderAppDynamicSettingsEnum;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OrderAppEngravingCoordinates = {
  x1: Scalars['Float']['input'];
  x2: Scalars['Float']['input'];
  y1: Scalars['Float']['input'];
  y2: Scalars['Float']['input'];
};

export type OrderAppEngravingInfoInput = {
  coordinates: OrderAppEngravingCoordinates;
  size: OrderAppEngravingSizeEnum;
  style: OrderAppEngravingStyleEnum;
  text: Scalars['String']['input'];
  type: OrderAppEngravingTypeEnum;
};

export type OrderAppEngravingSizeEnum =
  | 'L'
  | 'M';

export type OrderAppEngravingStyleEnum =
  | 'BLOCK'
  | 'CURSIVE';

export type OrderAppEngravingTypeEnum =
  | 'DATE'
  | 'INITIALS'
  | 'MESSAGE';

export type OrderAppError = {
  __typename?: 'Error';
  code: Scalars['String']['output'];
  context: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type OrderAppGuestContextInput = {
  email: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
};

export type OrderAppGuestLookupInput = {
  businessId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
};

export type OrderAppGwpProduct = {
  __typename?: 'GwpProduct';
  available_quantity: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  product_type_slug: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  threshhold: Scalars['String']['output'];
  thumbnail_alt: Maybe<Scalars['String']['output']>;
  thumbnail_url: Maybe<Scalars['String']['output']>;
};

export type OrderAppIdOnlyOrder = {
  __typename?: 'IdOnlyOrder';
  id: Scalars['ID']['output'];
};

export type OrderAppImage = {
  __typename?: 'Image';
  alt: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type OrderAppInvitationMethod =
  | 'MAIL'
  | 'SMS';

export type OrderAppLanguageCodeEnum =
  | 'DE'
  | 'EN_GB'
  | 'EN_US'
  | 'ES'
  | 'FR'
  | 'IT'
  | 'JA'
  | 'KO'
  | 'PT'
  | 'RU'
  | 'ZH_HANT'
  | 'ZH_HANT_TW';

export type OrderAppMarketPreOrderConfigInput = {
  availableFrom?: InputMaybe<Scalars['DateTime']['input']>;
  availableTo?: InputMaybe<Scalars['DateTime']['input']>;
  dedicatedStock?: InputMaybe<Scalars['Int']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  depositPercentage?: InputMaybe<Scalars['Int']['input']>;
  forcePreOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isInfiniteStock?: InputMaybe<Scalars['Boolean']['input']>;
  market: Scalars['String']['input'];
  notifyMe?: InputMaybe<Scalars['Boolean']['input']>;
  preOrder?: InputMaybe<OrderAppPreOrderConfigEnum>;
};

export type OrderAppMarketSellable = {
  __typename?: 'MarketSellable';
  market: Scalars['String']['output'];
  sellable: Maybe<Scalars['Boolean']['output']>;
  sellingType: Maybe<OrderAppSellingTypeEnum>;
};

export type OrderAppMarketVisible = {
  __typename?: 'MarketVisible';
  market: Scalars['String']['output'];
  visible: Maybe<Scalars['Boolean']['output']>;
};

export type OrderAppMetadataInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type OrderAppMetadataItem = {
  __typename?: 'MetadataItem';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OrderAppMoney = {
  __typename?: 'Money';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
};

export type OrderAppMutation = {
  __typename?: 'Mutation';
  checkoutCreate: Maybe<OrderAppCheckoutCreate>;
  checkoutLinesAdd: OrderAppCheckoutLinesAddResult;
  checkoutLinesDelete: OrderAppCheckoutLinesDeleteResult;
  checkoutShippingAddressUpdate: OrderAppCheckoutShippingAddressUpdateResult;
  checkoutVoucherAdd: OrderAppCheckoutVoucherAddResult;
  checkoutVoucherDelete: OrderAppCheckoutVoucherDeleteResult;
  deleteMetadata: OrderAppDeleteMetadata;
  deliveryModeUpdate: OrderAppDeliveryModeUpdateResult;
  draftOrderComplete: OrderAppDraftOrderCompleteResult;
  draftOrderCreate: OrderAppDraftOrderCreateResult;
  editSetting: OrderAppSettingResult;
  gwpCheckoutUpdate: OrderAppCheckoutGwpUpdateResult;
  gwpOrderUpdate: OrderAppOrderGwpUpdateResult;
  offlinePaymentConfirm: OrderAppOfflinePaymentConfirmResult;
  offlinePaymentEmailDetails: OrderAppOfflinePaymentEmailResult;
  offlinePaymentToggle: OrderAppOfflinePaymentToggleResult;
  orderAbandon: OrderAppOrderAbandonResult;
  orderCancel: OrderAppOrderCancelResult;
  orderCreate: OrderAppOrderCreateResult;
  orderDiscountAdd: OrderAppOrderDiscountAddResult;
  orderFreeShippingAdd: OrderAppOrderFreeShippingAddResult;
  orderGenerateBusinessId: OrderAppOrderGenerateBusinessIdResult;
  orderGenerateInvoice: OrderAppOrderGenerateInvoiceResult;
  orderLineDelete: OrderAppOrderLineDeleteResult;
  orderLineDiscountRemove: OrderAppOrderLineDiscountRemove;
  orderLineDiscountUpdate: OrderAppOrderLineDiscountUpdateResult;
  orderLinesCreate: OrderAppOrderLinesCreateResult;
  orderReturnCancel: Maybe<OrderAppOrderReturnCreate>;
  orderReturnCreate: Maybe<OrderAppOrderReturnCreate>;
  orderReturnReject: Maybe<OrderAppOrderReturnRejectResult>;
  orderSendPaymentInvitation: OrderAppOrderSendPaymentInvitationResult;
  orderShippingAddressUpdate: OrderAppOrderShippingAddressUpdateResult;
  orderUpdateClientDetails: OrderAppOrderUpdateClientDetailsResult;
  orderVoucherAdd: OrderAppOrderVoucherAddResult;
  orderVoucherDelete: OrderAppOrderVoucherDeleteResult;
  paymentCaptureRetry: OrderAppPaymentCaptureRetryResult;
  productVariantBulkUpdate: OrderAppProductVariantBulkUpdateResult;
  productVariantUpdate: OrderAppProductVariantUpdateResult;
  refundCreate: OrderAppRefundCreateResult;
  rerouteFulfillmentLocation: OrderAppRerouteFulfillmentLocationResult;
  resendReturnLabel: OrderAppResendReturnLabelResponse;
  sendInvoice: OrderAppSendInvoiceResponse;
  shippingUpdate: OrderAppShippingUpdateResult;
  subscriptionUpdate: OrderAppSubscriptionUpdateResult;
  updateEngravingInfo: OrderAppUpdateEngravingInfoResult;
  updateMetadata: OrderAppUpdateMetadataResult;
  withdrawalSubmit: OrderAppWithdrawalSubmitResult;
};


export type OrderAppMutationCheckoutCreateArgs = {
  input?: InputMaybe<OrderAppCheckoutCreateInput>;
};


export type OrderAppMutationCheckoutLinesAddArgs = {
  id: Scalars['ID']['input'];
  lines: Array<OrderAppCheckoutLineInput>;
  sellingType?: InputMaybe<OrderAppSellingTypeEnum>;
};


export type OrderAppMutationCheckoutLinesDeleteArgs = {
  id: Scalars['ID']['input'];
  linesIds: Array<Scalars['ID']['input']>;
  sellingType?: InputMaybe<OrderAppSellingTypeEnum>;
};


export type OrderAppMutationCheckoutShippingAddressUpdateArgs = {
  id: Scalars['ID']['input'];
  shippingAddress: OrderAppAddressInput;
  validationRules?: InputMaybe<OrderAppCheckoutAddressValidationRules>;
};


export type OrderAppMutationCheckoutVoucherAddArgs = {
  code: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type OrderAppMutationCheckoutVoucherDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type OrderAppMutationDeleteMetadataArgs = {
  id: Scalars['ID']['input'];
  keys: Array<Scalars['String']['input']>;
};


export type OrderAppMutationDeliveryModeUpdateArgs = {
  address?: InputMaybe<OrderAppAddressInput>;
  boutiqueExtReference?: InputMaybe<Scalars['String']['input']>;
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  deliveryMode: OrderAppDeliveryMode;
  draftOrderId?: InputMaybe<Scalars['ID']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
};


export type OrderAppMutationDraftOrderCompleteArgs = {
  id: Scalars['ID']['input'];
  source?: OrderAppOrderSource;
};


export type OrderAppMutationDraftOrderCreateArgs = {
  input: OrderAppDraftOrderCreateInput;
};


export type OrderAppMutationEditSettingArgs = {
  input?: InputMaybe<OrderAppEditSettingInput>;
};


export type OrderAppMutationGwpCheckoutUpdateArgs = {
  checkoutGwp: OrderAppCheckoutGwpInput;
  id: Scalars['ID']['input'];
};


export type OrderAppMutationGwpOrderUpdateArgs = {
  id: Scalars['ID']['input'];
  orderGwp: OrderAppOrderGwpInput;
};


export type OrderAppMutationOfflinePaymentConfirmArgs = {
  orderId: Scalars['ID']['input'];
};


export type OrderAppMutationOfflinePaymentEmailDetailsArgs = {
  orderId: Scalars['ID']['input'];
  paymentMethodType: OrderAppOfflinePaymentMethodTypeEnum;
};


export type OrderAppMutationOfflinePaymentToggleArgs = {
  isOfflinePayment: Scalars['Boolean']['input'];
  orderId: Scalars['ID']['input'];
};


export type OrderAppMutationOrderAbandonArgs = {
  checkoutId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
};


export type OrderAppMutationOrderCancelArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  reason: OrderAppOrderCancelReason;
  sendEmail?: Scalars['Boolean']['input'];
};


export type OrderAppMutationOrderCreateArgs = {
  id: Scalars['ID']['input'];
};


export type OrderAppMutationOrderDiscountAddArgs = {
  force?: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  input: OrderAppOrderDiscountAddInput;
};


export type OrderAppMutationOrderFreeShippingAddArgs = {
  id: Scalars['ID']['input'];
};


export type OrderAppMutationOrderGenerateBusinessIdArgs = {
  id: Scalars['ID']['input'];
};


export type OrderAppMutationOrderGenerateInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type OrderAppMutationOrderLineDeleteArgs = {
  id: Scalars['ID']['input'];
  lineId: Scalars['ID']['input'];
};


export type OrderAppMutationOrderLineDiscountRemoveArgs = {
  orderLineId: Scalars['ID']['input'];
};


export type OrderAppMutationOrderLineDiscountUpdateArgs = {
  force?: Scalars['Boolean']['input'];
  input: OrderAppOrderLineDiscountUpdateInput;
  orderId: Scalars['ID']['input'];
  orderLineId: Scalars['ID']['input'];
};


export type OrderAppMutationOrderLinesCreateArgs = {
  id: Scalars['ID']['input'];
  lines: Array<OrderAppOrderLineInput>;
  sellingType?: InputMaybe<OrderAppSellingTypeEnum>;
};


export type OrderAppMutationOrderReturnCancelArgs = {
  fulfillment_bid: Scalars['String']['input'];
  orderLineIds: Array<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type OrderAppMutationOrderReturnCreateArgs = {
  input?: InputMaybe<Array<OrderAppOrderReturnItemLine>>;
  order_id: Scalars['ID']['input'];
};


export type OrderAppMutationOrderReturnRejectArgs = {
  fulfillment_bid: Scalars['String']['input'];
  input: OrderAppOrderReturnRejectItemsInput;
};


export type OrderAppMutationOrderSendPaymentInvitationArgs = {
  id: Scalars['ID']['input'];
  invitationMethod: OrderAppInvitationMethod;
};


export type OrderAppMutationOrderShippingAddressUpdateArgs = {
  id: Scalars['ID']['input'];
  shippingAddress: OrderAppAddressInput;
};


export type OrderAppMutationOrderUpdateClientDetailsArgs = {
  id: Scalars['ID']['input'];
};


export type OrderAppMutationOrderVoucherAddArgs = {
  code: Scalars['String']['input'];
  force?: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type OrderAppMutationOrderVoucherDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type OrderAppMutationPaymentCaptureRetryArgs = {
  orderId: Scalars['ID']['input'];
};


export type OrderAppMutationProductVariantBulkUpdateArgs = {
  input: Array<OrderAppProductVariantInput>;
};


export type OrderAppMutationProductVariantUpdateArgs = {
  input: OrderAppProductVariantInput;
};


export type OrderAppMutationRefundCreateArgs = {
  order_id: Scalars['ID']['input'];
  refund_lines: Array<OrderAppRefundLine>;
  return_bid: Scalars['ID']['input'];
  silent?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrderAppMutationRerouteFulfillmentLocationArgs = {
  omsFulfillmentId?: InputMaybe<Scalars['String']['input']>;
  omsOrderId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  rerouteToLocation?: InputMaybe<Scalars['String']['input']>;
};


export type OrderAppMutationResendReturnLabelArgs = {
  fulfillmentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type OrderAppMutationSendInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type OrderAppMutationShippingUpdateArgs = {
  id: Scalars['ID']['input'];
  type: OrderAppOrderShipping;
};


export type OrderAppMutationSubscriptionUpdateArgs = {
  id: Scalars['ID']['input'];
  status: OrderAppOrderSubscription;
};


export type OrderAppMutationUpdateEngravingInfoArgs = {
  id: Scalars['ID']['input'];
  input: OrderAppEngravingInfoInput;
  lineId: Scalars['ID']['input'];
};


export type OrderAppMutationUpdateMetadataArgs = {
  id: Scalars['ID']['input'];
  input: Array<OrderAppMetadataInput>;
};


export type OrderAppMutationWithdrawalSubmitArgs = {
  input: OrderAppWithdrawalSubmitInput;
};

export type OrderAppObjectWithMetadata = {
  __typename?: 'ObjectWithMetadata';
  metadata: Array<OrderAppMetadataItem>;
  metafield: Maybe<Scalars['String']['output']>;
};


export type OrderAppObjectWithMetadataMetafieldArgs = {
  key: Scalars['String']['input'];
};

export type OrderAppOfflinePaymentConfirmResult = {
  __typename?: 'OfflinePaymentConfirmResult';
  errors: Array<OrderAppError>;
};

export type OrderAppOfflinePaymentEmailResult = {
  __typename?: 'OfflinePaymentEmailResult';
  errors: Array<OrderAppError>;
};

export type OrderAppOfflinePaymentMethodTypeEnum =
  | 'OFFLINE_BANKTRANSFER';

export type OrderAppOfflinePaymentToggleResult = {
  __typename?: 'OfflinePaymentToggleResult';
  errors: Array<OrderAppError>;
};

export type OrderAppOrder = {
  __typename?: 'Order';
  billingAddress: Maybe<OrderAppAddress>;
  businessId: Scalars['ID']['output'];
  channel: OrderAppChannel;
  discounts: Maybe<Array<OrderAppOrderDiscount>>;
  hasEngraving: Scalars['Boolean']['output'];
  hasRefund: Scalars['Boolean']['output'];
  hasWarrantyExtension: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isValid: OrderAppOrderValidationStatus;
  lines: Maybe<Array<OrderAppOrderLine>>;
  payPerLinkExpiration: Maybe<Scalars['Float']['output']>;
  payPerLinkUrl: Maybe<Scalars['String']['output']>;
  payment: Maybe<OrderAppOrderPayment>;
  paymentRequest: OrderAppPaymentRequestData;
  preOrderDeposit: Maybe<OrderAppMoney>;
  preOrderDepositPercentage: Maybe<Scalars['Int']['output']>;
  return: Maybe<OrderAppOrderReturn>;
  shipping: Maybe<OrderAppOrderShipping>;
  shippingAddress: Maybe<OrderAppAddress>;
  source: Maybe<OrderAppOrderSource>;
  status: Maybe<OrderAppOrderStatus>;
  subscription: Maybe<OrderAppOrderSubscription>;
  type: Maybe<OrderAppOrderType>;
  user: Maybe<OrderAppUser>;
  userEmail: Maybe<Scalars['String']['output']>;
};


export type OrderAppOrderIsValidArgs = {
  newLines?: InputMaybe<Array<OrderAppOrderLineValidation>>;
};

export type OrderAppOrderAbandonResult = {
  __typename?: 'OrderAbandonResult';
  errors: Array<OrderAppError>;
  newBusinessId: Maybe<Scalars['String']['output']>;
};

export type OrderAppOrderCancelReason =
  | 'CHANGE_OF_MIND'
  | 'FRAUD'
  | 'NO_REASON_GIVEN'
  | 'OTHERS'
  | 'PURCHASED_CHEAPER'
  | 'PURCHASED_DUPLICATE'
  | 'PURCHASED_ELSEWHERE'
  | 'PURCHASED_MISTAKE'
  | 'WRONG_COLOR'
  | 'WRONG_MODEL'
  | 'WRONG_SIZE';

export type OrderAppOrderCancelResult = {
  __typename?: 'OrderCancelResult';
  canceled: Scalars['Boolean']['output'];
  errors: Array<OrderAppError>;
  order: Maybe<OrderAppOrder>;
};

export type OrderAppOrderCreateResult = {
  __typename?: 'OrderCreateResult';
  errors: Array<OrderAppError>;
  order: Maybe<OrderAppOrder>;
};

export type OrderAppOrderDiscount = {
  __typename?: 'OrderDiscount';
  amount: OrderAppMoney;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  reason: Maybe<Scalars['String']['output']>;
  type: OrderAppOrderDiscountType;
  value: Scalars['Float']['output'];
  valueType: OrderAppDiscountValueType;
};

export type OrderAppOrderDiscountAddInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Float']['input'];
  valueType: OrderAppDiscountValueType;
};

export type OrderAppOrderDiscountAddResult = {
  __typename?: 'OrderDiscountAddResult';
  errors: Array<OrderAppError>;
  order: Maybe<OrderAppOrder>;
};

export type OrderAppOrderDiscountType =
  | 'MANUAL'
  | 'ORDER_PROMOTION'
  | 'PROMOTION'
  | 'SALE'
  | 'VOUCHER';

export type OrderAppOrderFreeShippingAddResult = {
  __typename?: 'OrderFreeShippingAddResult';
  errors: Array<OrderAppError>;
  order: Maybe<OrderAppOrder>;
};

export type OrderAppOrderGenerateBusinessIdResult = {
  __typename?: 'OrderGenerateBusinessIdResult';
  businessId: Maybe<Scalars['String']['output']>;
  errors: Array<OrderAppError>;
};

export type OrderAppOrderGenerateInvoiceResult = {
  __typename?: 'OrderGenerateInvoiceResult';
  errors: Array<OrderAppError>;
};

export type OrderAppOrderGwpInput = {
  gwpProductId: Scalars['String']['input'];
  lineIdToRemove: Scalars['String']['input'];
};

export type OrderAppOrderGwpUpdateResult = {
  __typename?: 'OrderGwpUpdateResult';
  errors: Array<OrderAppError>;
};

export type OrderAppOrderLine = {
  __typename?: 'OrderLine';
  discounts: Maybe<Array<OrderAppOrderLineDiscount>>;
  hasWarrantyExtension: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  metadata: Maybe<Array<OrderAppMetadataItem>>;
  quantity: Scalars['Int']['output'];
  strapPackReference: Maybe<Scalars['String']['output']>;
  strapReference: Maybe<Scalars['String']['output']>;
  totalPrice: OrderAppTaxedMoney;
  undiscountedUnitPrice: OrderAppTaxedMoney;
  unitDiscount: OrderAppMoney;
  unitDiscountType: Maybe<OrderAppDiscountValueType>;
  unitDiscountValue: Scalars['Float']['output'];
  unitPrice: OrderAppTaxedMoney;
  variant: OrderAppProductVariant;
  warrantyExtensionDuration: Maybe<Scalars['String']['output']>;
  warrantyExtensionId: Maybe<Scalars['String']['output']>;
  watchLineId: Maybe<Scalars['String']['output']>;
};

export type OrderAppOrderLineDeleteResult = {
  __typename?: 'OrderLineDeleteResult';
  errors: Array<OrderAppError>;
  order: Maybe<OrderAppOrder>;
};

export type OrderAppOrderLineDiscount = {
  __typename?: 'OrderLineDiscount';
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  reason: Maybe<Scalars['String']['output']>;
  total: OrderAppMoney;
  translatedName: Maybe<Scalars['String']['output']>;
  type: OrderAppOrderDiscountType;
  value: Scalars['Float']['output'];
  valueType: OrderAppDiscountValueType;
};

export type OrderAppOrderLineDiscountRemove = {
  __typename?: 'OrderLineDiscountRemove';
  errors: Array<OrderAppError>;
  order: Maybe<OrderAppOrder>;
  orderLine: Maybe<OrderAppOrderLine>;
};

export type OrderAppOrderLineDiscountUpdateInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Float']['input'];
  valueType: OrderAppDiscountValueType;
};

export type OrderAppOrderLineDiscountUpdateResult = {
  __typename?: 'OrderLineDiscountUpdateResult';
  errors: Array<OrderAppError>;
  order: Maybe<OrderAppOrder>;
  orderLine: Maybe<OrderAppOrderLine>;
};

export type OrderAppOrderLineInput = {
  forceNewLine?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<OrderAppMetadataInput>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Strap pack input, required if we adding product type of Strap Pack */
  strapPackInput?: InputMaybe<OrderAppStrapPackInput>;
  /** Related strap products inputs */
  strapRelatedProducts?: InputMaybe<OrderAppStrapRelatedProductsInput>;
  variantId: Scalars['ID']['input'];
  /** Checkout line id of watch, required if we adding product type of Warranty */
  watchLineId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrderAppOrderLineValidation = {
  productVariantId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type OrderAppOrderLinesCreateResult = {
  __typename?: 'OrderLinesCreateResult';
  errors: Array<OrderAppError>;
  order: Maybe<OrderAppOrder>;
};

export type OrderAppOrderPayment =
  | 'PARTIAL_IN_VALIDATION'
  | 'PARTIAL_RECEIVED'
  | 'PARTIAL_REJECTED'
  | 'PREORDER_REJECTED';

export type OrderAppOrderReturn =
  | 'ACCEPTED'
  | 'CANCELLED'
  | 'IN_RETURN'
  | 'RECEIVED'
  | 'REGISTERED'
  | 'REJECTED';

export type OrderAppOrderReturnCreate = {
  __typename?: 'OrderReturnCreate';
  errors: Maybe<Array<OrderAppError>>;
  order: Maybe<OrderAppOrder>;
};

export type OrderAppOrderReturnItemLine = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  reason: OrderAppOrderReturnReason;
};

export type OrderAppOrderReturnReason =
  | 'BETTER_PRICE_ELSEWHERE'
  | 'DID_NOT_LIKE_COLOR'
  | 'DID_NOT_LIKE_SIZE'
  | 'DID_NOT_PAY'
  | 'LOST_PACKAGE'
  | 'OTHERS'
  | 'PURCHASED_AS_GIFT'
  | 'PURCHASED_DIFFERENT_BRAND'
  | 'REFUSE_PACKAGE'
  | 'STYLE_NOT_AS_EXPECTED';

export type OrderAppOrderReturnRejectItemInput = {
  order_line_id: Scalars['String']['input'];
};

export type OrderAppOrderReturnRejectItemsInput = {
  items: Array<OrderAppOrderReturnRejectItemInput>;
};

export type OrderAppOrderReturnRejectResult = {
  __typename?: 'OrderReturnRejectResult';
  errors: Maybe<Array<OrderAppError>>;
};

export type OrderAppOrderSendPaymentInvitationResult = {
  __typename?: 'OrderSendPaymentInvitationResult';
  errors: Array<OrderAppError>;
};

export type OrderAppOrderShipping =
  | 'BOUTIQUE'
  | 'CC'
  | 'HOME';

export type OrderAppOrderShippingAddressUpdateResult = {
  __typename?: 'OrderShippingAddressUpdateResult';
  errors: Array<OrderAppError>;
};

export type OrderAppOrderSource =
  | 'BOUTIQUE'
  | 'FOR_GIFT'
  | 'GIFT'
  | 'PHONE'
  | 'RETAIL'
  | 'WEBSITE';

export type OrderAppOrderStatus =
  | 'ABANDONED'
  | 'CANCELLED'
  | 'COLLECTED'
  | 'CONFIRMED'
  | 'DRAFT'
  | 'IN_PREPARATION'
  | 'IN_VALIDATION'
  | 'PARTIALLY_IN_PREPARATION'
  | 'PARTIALLY_PAID'
  | 'PARTIALLY_READY_TO_SHIP'
  | 'PARTIALLY_RETURNED'
  | 'PARTIALLY_SHIPPED'
  | 'PARTIAL_PAYMENT_IN_VALIDATION'
  | 'PARTIAL_PAYMENT_RECEIVED'
  | 'PARTIAL_PAYMENT_REJECTED'
  | 'PENDING'
  | 'PREORDER_CANCELLED'
  | 'READY_FOR_COLLECTION'
  | 'READY_TO_SHIP'
  | 'REJECTED'
  | 'RETURNED'
  | 'RETURN_ACCEPTED'
  | 'RETURN_RECEIVED'
  | 'RETURN_REGISTERED'
  | 'RETURN_REJECTED'
  | 'SHIPPED';

export type OrderAppOrderSubscription =
  | 'CLOSED'
  | 'CONFIRMED'
  | 'PAYMENT_ERROR'
  | 'PENDING_CANCEL'
  | 'PENDING_ROTATION'
  | 'SUSPENDED'
  | 'VALIDATION';

export type OrderAppOrderType =
  | 'ORDER'
  | 'PRE_ORDER'
  | 'ROTATION'
  | 'SUBSCRIPTION'
  | 'WARRANTY_EXTENSION';

export type OrderAppOrderUpdateClientDetailsResult = {
  __typename?: 'OrderUpdateClientDetailsResult';
  errors: Array<OrderAppError>;
};

export type OrderAppOrderValidationResult = {
  __typename?: 'OrderValidationResult';
  errors: Array<OrderAppError>;
  id: Scalars['ID']['output'];
  valid: Scalars['Boolean']['output'];
};

export type OrderAppOrderValidationStatus = {
  __typename?: 'OrderValidationStatus';
  message: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type OrderAppOrderVoucherAddResult = {
  __typename?: 'OrderVoucherAddResult';
  errors: Array<OrderAppError>;
  order: Maybe<OrderAppOrder>;
};

export type OrderAppOrderVoucherDeleteResult = {
  __typename?: 'OrderVoucherDeleteResult';
  errors: Array<OrderAppError>;
  order: Maybe<OrderAppOrder>;
};

export type OrderAppPayPerLinkOrder = {
  __typename?: 'PayPerLinkOrder';
  businessId: Scalars['String']['output'];
  channel: OrderAppChannel;
  expirationTimestamp: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  lines: Array<OrderAppPayPerLinkOrderLine>;
  paymentRequest: OrderAppPaymentRequestData;
  preOrderDeposit: Maybe<OrderAppMoney>;
  preOrderDepositPercentage: Maybe<Scalars['Int']['output']>;
  shippingAddress: OrderAppAddress;
  shippingPrice: OrderAppTaxedMoney;
  subtotal: OrderAppTaxedMoney;
  total: OrderAppTaxedMoney;
  userEmail: Scalars['String']['output'];
};

export type OrderAppPayPerLinkOrderLine = {
  __typename?: 'PayPerLinkOrderLine';
  id: Scalars['String']['output'];
  isShippingRequired: Scalars['Boolean']['output'];
  metadata: Maybe<Array<OrderAppMetadataItem>>;
  productName: Maybe<Scalars['String']['output']>;
  productSku: Maybe<Scalars['String']['output']>;
  productVariantId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  quantityFulfilled: Scalars['Int']['output'];
  quantityToFulfill: Scalars['Int']['output'];
  taxRate: Maybe<Scalars['Float']['output']>;
  thumbnail: Maybe<OrderAppThumbnail>;
  totalPrice: OrderAppTaxedMoney;
  undiscountedUnitPrice: OrderAppTaxedMoney;
  unitDiscount: OrderAppMoney;
  unitDiscountReason: Maybe<Scalars['String']['output']>;
  unitDiscountType: Maybe<OrderAppDiscountValueTypeEnum>;
  unitDiscountValue: Scalars['Float']['output'];
  unitPrice: OrderAppTaxedMoney;
  variant: Maybe<OrderAppPaymentProductVariant>;
  variantName: Maybe<Scalars['String']['output']>;
};

export type OrderAppPaymentCaptureRetryResult = {
  __typename?: 'PaymentCaptureRetryResult';
  errors: Array<OrderAppError>;
};

export type OrderAppPaymentProduct = {
  __typename?: 'PaymentProduct';
  category: Maybe<OrderAppCategory>;
  id: Scalars['ID']['output'];
  metadata: Maybe<Array<OrderAppMetadataItem>>;
};

export type OrderAppPaymentProductVariant = {
  __typename?: 'PaymentProductVariant';
  id: Scalars['ID']['output'];
  product: OrderAppPaymentProduct;
};

export type OrderAppPaymentRequestData = {
  __typename?: 'PaymentRequestData';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  transactionType: OrderAppTransactionTypeEnum;
};

export type OrderAppPreOrderConfig = {
  __typename?: 'PreOrderConfig';
  availableFrom: Maybe<Scalars['DateTime']['output']>;
  availableTo: Maybe<Scalars['DateTime']['output']>;
  dedicatedStock: Maybe<Scalars['Int']['output']>;
  deliveryDate: Maybe<Scalars['DateTime']['output']>;
  depositPercentage: Maybe<Scalars['Int']['output']>;
  forcePreOrder: Maybe<Scalars['Boolean']['output']>;
  isInfiniteStock: Maybe<Scalars['Boolean']['output']>;
  market: Scalars['String']['output'];
  notifyMe: Maybe<Scalars['Boolean']['output']>;
  preOrder: Maybe<OrderAppPreOrderConfigEnum>;
};

export type OrderAppPreOrderConfigEnum =
  | 'OFF'
  | 'ON';

export type OrderAppProduct = {
  __typename?: 'Product';
  attribute: Maybe<OrderAppSelectedAttribute>;
  category: OrderAppCategory;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productType: OrderAppProductType;
  thumbnail: Maybe<OrderAppImage>;
  translation: Maybe<OrderAppProductTranslation>;
};


export type OrderAppProductAttributeArgs = {
  slug: Scalars['String']['input'];
};


export type OrderAppProductThumbnailArgs = {
  format?: InputMaybe<OrderAppThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type OrderAppProductTranslationArgs = {
  languageCode: OrderAppLanguageCodeEnum;
};

export type OrderAppProductTranslation = {
  __typename?: 'ProductTranslation';
  name: Maybe<Scalars['String']['output']>;
};

export type OrderAppProductType = {
  __typename?: 'ProductType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OrderAppProductVariant = {
  __typename?: 'ProductVariant';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  preOrderQuantityAvailable: Maybe<Scalars['Int']['output']>;
  product: OrderAppProduct;
  quantityAvailable: Scalars['Int']['output'];
  sellable: Maybe<Scalars['Boolean']['output']>;
  sku: Scalars['String']['output'];
  variantCTA: OrderAppCtaType;
};


export type OrderAppProductVariantSellableArgs = {
  sellingType?: InputMaybe<OrderAppSellingTypeEnum>;
};


export type OrderAppProductVariantVariantCtaArgs = {
  fromCPI?: InputMaybe<Scalars['Boolean']['input']>;
  sellingType?: InputMaybe<OrderAppSellingTypeEnum>;
};

export type OrderAppProductVariantBulkUpdateResult = {
  __typename?: 'ProductVariantBulkUpdateResult';
  errors: Array<OrderAppError>;
  results: Maybe<Array<OrderAppProductVariantUpdateResult>>;
};

export type OrderAppProductVariantInput = {
  preOrderConfig: Array<InputMaybe<OrderAppMarketPreOrderConfigInput>>;
  sku: Scalars['String']['input'];
};

export type OrderAppProductVariantUpdateResult = {
  __typename?: 'ProductVariantUpdateResult';
  errors: Array<OrderAppError>;
  preOrderConfig: Maybe<Array<Maybe<OrderAppPreOrderConfig>>>;
  sku: Maybe<Scalars['String']['output']>;
};

export type OrderAppProductVariantsWithPreOrderConfig = {
  __typename?: 'ProductVariantsWithPreOrderConfig';
  defaultVisible: Maybe<Scalars['Boolean']['output']>;
  marketSellable: Maybe<Array<Maybe<OrderAppMarketSellable>>>;
  marketVisible: Maybe<Array<Maybe<OrderAppMarketVisible>>>;
  phoneDefaultSellable: Maybe<Scalars['Boolean']['output']>;
  preOrderConfig: Maybe<Array<Maybe<OrderAppPreOrderConfig>>>;
  sku: Scalars['String']['output'];
  webDefaultSellable: Maybe<Scalars['Boolean']['output']>;
};

export type OrderAppQuery = {
  __typename?: 'Query';
  billingCountries: Array<OrderAppBillingCountry>;
  channelConfig: Maybe<OrderAppChannelConfig>;
  checkout: Maybe<OrderAppCheckout>;
  countriesChannels: Array<OrderAppCountryChannel>;
  dynamicSetting: OrderAppSettingResult;
  gwpProducts: Maybe<Array<OrderAppGwpProduct>>;
  order: Maybe<OrderAppOrder>;
  orderByPaymentToken: Maybe<OrderAppPayPerLinkOrder>;
  orderIdByBusinessIdAndEmail: Maybe<OrderAppIdOnlyOrder>;
  productVariant: Maybe<OrderAppProductVariant>;
  productVariants: Maybe<Array<OrderAppProductVariant>>;
  productVariantsWithPreOrderConfig: Maybe<Array<OrderAppProductVariantsWithPreOrderConfig>>;
  /**
   * Calculates the gross and tax refund amounts for the given net refund amounts
   * per line.
   */
  refundCalculateTax: OrderAppRefundCalculateTaxResult;
  /** Return reasons available to storefront and backoffice clients. */
  returnReasons: Array<OrderAppReturnReason>;
  storefrontOfflinePaymentAvailability: Scalars['Boolean']['output'];
  validateCheckout: OrderAppCheckoutValidationResult;
  validateOrder: OrderAppOrderValidationResult;
  voucher: Maybe<OrderAppVoucherObject>;
  withdrawalEligibility: OrderAppWithdrawalEligibilityResult;
};


export type OrderAppQueryChannelConfigArgs = {
  channel: Scalars['String']['input'];
};


export type OrderAppQueryCheckoutArgs = {
  id: Scalars['ID']['input'];
};


export type OrderAppQueryDynamicSettingArgs = {
  name: OrderAppDynamicSettingsEnum;
};


export type OrderAppQueryGwpProductsArgs = {
  brand?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  checkout_id?: InputMaybe<Scalars['String']['input']>;
  thresh_hold?: InputMaybe<Scalars['String']['input']>;
};


export type OrderAppQueryOrderArgs = {
  id: Scalars['ID']['input'];
};


export type OrderAppQueryOrderByPaymentTokenArgs = {
  token: Scalars['String']['input'];
};


export type OrderAppQueryOrderIdByBusinessIdAndEmailArgs = {
  brand?: InputMaybe<Scalars['String']['input']>;
  businessId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
};


export type OrderAppQueryProductVariantArgs = {
  channel: Scalars['String']['input'];
  sku: Scalars['String']['input'];
};


export type OrderAppQueryProductVariantsArgs = {
  channel: Scalars['String']['input'];
  skus: Array<Scalars['String']['input']>;
};


export type OrderAppQueryProductVariantsWithPreOrderConfigArgs = {
  skus: Array<Scalars['String']['input']>;
};


export type OrderAppQueryRefundCalculateTaxArgs = {
  orderId: Scalars['ID']['input'];
  refundLines: Array<OrderAppRefundCalculateTaxLineInput>;
};


export type OrderAppQueryReturnReasonsArgs = {
  audience?: InputMaybe<OrderAppReturnReasonAudience>;
};


export type OrderAppQueryStorefrontOfflinePaymentAvailabilityArgs = {
  id: Scalars['ID']['input'];
};


export type OrderAppQueryValidateCheckoutArgs = {
  checkAddress?: InputMaybe<Scalars['Boolean']['input']>;
  checkPrices?: InputMaybe<Scalars['Boolean']['input']>;
  checkStocks?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type OrderAppQueryValidateOrderArgs = {
  id: Scalars['ID']['input'];
};


export type OrderAppQueryVoucherArgs = {
  channel: Scalars['String']['input'];
  code: Scalars['String']['input'];
};


export type OrderAppQueryWithdrawalEligibilityArgs = {
  input: OrderAppWithdrawalEligibilityInput;
};

export type OrderAppReferenceDateSource =
  | 'DELIVERED'
  | 'ORDER_EVENT';

export type OrderAppRefundAmount = {
  gross: Scalars['Float']['input'];
  net: Scalars['Float']['input'];
  tax: Scalars['Float']['input'];
};

export type OrderAppRefundCalculateTaxLineInput = {
  orderLineId: Scalars['ID']['input'];
  refundAmount: Scalars['Float']['input'];
};

export type OrderAppRefundCalculateTaxLineResult = {
  __typename?: 'RefundCalculateTaxLineResult';
  gross: Scalars['Float']['output'];
  net: Scalars['Float']['output'];
  orderLineId: Scalars['ID']['output'];
  tax: Scalars['Float']['output'];
};

export type OrderAppRefundCalculateTaxResult = {
  __typename?: 'RefundCalculateTaxResult';
  refundLines: Array<OrderAppRefundCalculateTaxLineResult>;
};

export type OrderAppRefundCreateResult = {
  __typename?: 'RefundCreateResult';
  errors: Array<OrderAppError>;
};

export type OrderAppRefundLine = {
  amount: OrderAppRefundAmount;
  comment?: InputMaybe<Scalars['String']['input']>;
  order_line_id: Scalars['ID']['input'];
};

export type OrderAppRerouteFulfillmentLocationResult = {
  __typename?: 'RerouteFulfillmentLocationResult';
  errors: Array<OrderAppError>;
  success: Scalars['Boolean']['output'];
};

export type OrderAppResendReturnLabelResponse = {
  __typename?: 'ResendReturnLabelResponse';
  errors: Array<OrderAppError>;
  success: Scalars['Boolean']['output'];
};

/** User-selectable return reason with stable identifier and localized labels. */
export type OrderAppReturnReason = {
  __typename?: 'ReturnReason';
  /** Client audiences for which this reason should be displayed. */
  audiences: Array<OrderAppReturnReasonAudience>;
  /** Stable identifier matching the values accepted by orderReturnCreate. */
  id: Scalars['ID']['output'];
  /** Localized labels ordered by supported language. */
  translations: Array<OrderAppReturnReasonTranslation>;
};

export type OrderAppReturnReasonAudience =
  | 'BACKOFFICE'
  | 'STOREFRONT';

/** Localized label for a return reason. */
export type OrderAppReturnReasonTranslation = {
  __typename?: 'ReturnReasonTranslation';
  /** Supported language code for this translation. */
  languageCode: Scalars['String']['output'];
  /** User-facing label shown for the return reason. */
  value: Scalars['String']['output'];
};

export type OrderAppSelectedAttribute = {
  __typename?: 'SelectedAttribute';
  attribute: OrderAppAttribute;
  values: Array<OrderAppAttributeValue>;
};

export type OrderAppSellingTypeEnum =
  | 'PHONE'
  | 'WEB';

export type OrderAppSendInvoiceResponse = {
  __typename?: 'SendInvoiceResponse';
  errors: Array<OrderAppError>;
  success: Scalars['Boolean']['output'];
};

export type OrderAppSetting = {
  __typename?: 'Setting';
  modified: Maybe<Scalars['Float']['output']>;
  modifiedBy: Scalars['String']['output'];
  name: OrderAppDynamicSettingsEnum;
  value: Maybe<Scalars['String']['output']>;
};

export type OrderAppSettingResult = {
  __typename?: 'SettingResult';
  errors: Array<OrderAppError>;
  setting: Maybe<OrderAppSetting>;
};

export type OrderAppShippingUpdateResult = {
  __typename?: 'ShippingUpdateResult';
  errors: Array<OrderAppError>;
  order: Maybe<OrderAppOrder>;
};

export type OrderAppStrapItemInput = {
  additionalBuckle?: InputMaybe<Scalars['String']['input']>;
  reference: Scalars['String']['input'];
};

export type OrderAppStrapPackInput = {
  strapItem1: OrderAppStrapItemInput;
  strapItem2: OrderAppStrapItemInput;
};

export type OrderAppStrapRelatedProductsInput = {
  buckleId: Scalars['String']['input'];
};

export type OrderAppSubscriptionUpdateResult = {
  __typename?: 'SubscriptionUpdateResult';
  errors: Array<OrderAppError>;
  order: Maybe<OrderAppOrder>;
};

export type OrderAppTaxedMoney = {
  __typename?: 'TaxedMoney';
  currency: Scalars['String']['output'];
  gross: OrderAppMoney;
  net: OrderAppMoney;
  tax: OrderAppMoney;
};

export type OrderAppThumbnail = {
  __typename?: 'Thumbnail';
  url: Scalars['String']['output'];
};

export type OrderAppThumbnailFormatEnum =
  | 'AVIF'
  | 'ORIGINAL'
  | 'WEBP';

export type OrderAppTransactionTypeEnum =
  | 'BALANCE'
  | 'DEPOSIT'
  | 'FULL';

export type OrderAppUpdateEngravingInfoResult = {
  __typename?: 'UpdateEngravingInfoResult';
  errors: Array<OrderAppError>;
};

export type OrderAppUpdateMetadataResult = {
  __typename?: 'UpdateMetadataResult';
  errors: Array<OrderAppError>;
  item: Maybe<OrderAppObjectWithMetadata>;
};

export type OrderAppUser = {
  __typename?: 'User';
  addresses: Maybe<Array<Maybe<OrderAppAddress>>>;
  dateJoined: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Maybe<Scalars['Boolean']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
};

export type OrderAppVoucherObject = {
  __typename?: 'VoucherObject';
  discountValueType: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OrderAppWithdrawalAccessMode =
  | 'AUTHENTICATED'
  | 'GUEST'
  | 'STAFF';

export type OrderAppWithdrawalCustomer = {
  __typename?: 'WithdrawalCustomer';
  email: Scalars['String']['output'];
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
};

export type OrderAppWithdrawalEligibilityCode =
  | 'OK';

export type OrderAppWithdrawalEligibilityInput = {
  brand: Scalars['String']['input'];
  guestLookup?: InputMaybe<OrderAppGuestLookupInput>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrderAppWithdrawalEligibilityResult = {
  __typename?: 'WithdrawalEligibilityResult';
  errors: Array<OrderAppError>;
  withdrawal: Maybe<OrderAppWithdrawalInfo>;
};

export type OrderAppWithdrawalInfo = {
  __typename?: 'WithdrawalInfo';
  accessMode: OrderAppWithdrawalAccessMode;
  code: OrderAppWithdrawalEligibilityCode;
  customer: OrderAppWithdrawalCustomer;
  lines: Array<OrderAppWithdrawalLine>;
  order: OrderAppWithdrawalOrderSummary;
};

export type OrderAppWithdrawalLine = {
  __typename?: 'WithdrawalLine';
  disabledReasonCode: Maybe<OrderAppDisabledReasonCode>;
  eligibleQuantity: Scalars['Int']['output'];
  orderLineId: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  referenceDate: Maybe<Scalars['DateTime']['output']>;
  referenceDateSource: Maybe<OrderAppReferenceDateSource>;
  sku: Scalars['String']['output'];
  status: OrderAppWithdrawalLineStatus;
  windowEndAt: Maybe<Scalars['DateTime']['output']>;
};

export type OrderAppWithdrawalLineStatus =
  | 'ELIGIBLE'
  | 'INELIGIBLE';

export type OrderAppWithdrawalOrderSummary = {
  __typename?: 'WithdrawalOrderSummary';
  businessId: Scalars['String']['output'];
  channel: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type OrderAppWithdrawalSubmitCode =
  | 'OK';

export type OrderAppWithdrawalSubmitInfo = {
  __typename?: 'WithdrawalSubmitInfo';
  code: OrderAppWithdrawalSubmitCode;
  items: Array<OrderAppWithdrawalSubmitLine>;
  submittedAt: Scalars['DateTime']['output'];
  withdrawalRequestId: Scalars['ID']['output'];
};

export type OrderAppWithdrawalSubmitInput = {
  brand: Scalars['String']['input'];
  guestContext?: InputMaybe<OrderAppGuestContextInput>;
  items: Array<OrderAppWithdrawalSubmitLineInput>;
  orderId: Scalars['ID']['input'];
};

export type OrderAppWithdrawalSubmitLine = {
  __typename?: 'WithdrawalSubmitLine';
  comment: Maybe<Scalars['String']['output']>;
  orderLineId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  reasonCode: Maybe<OrderAppOrderReturnReason>;
  status: Scalars['String']['output'];
  translatedReason: Maybe<Scalars['String']['output']>;
};

export type OrderAppWithdrawalSubmitLineInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  orderLineId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  reasonCode?: InputMaybe<OrderAppOrderReturnReason>;
  translatedReason?: InputMaybe<Scalars['String']['input']>;
};

export type OrderAppWithdrawalSubmitResult = {
  __typename?: 'WithdrawalSubmitResult';
  errors: Array<OrderAppError>;
  withdrawalSubmit: Maybe<OrderAppWithdrawalSubmitInfo>;
};

export type OrderAppOrderAppBillingCountryFragment = { __typename?: 'BillingCountry', code: string | null, name: string | null };

export type OrderAppOrderAppErrorFragment = { __typename?: 'Error', field: string, code: string, context: string | null, message: string };

export type OrderAppGiftMetadataFragment = { __typename?: 'ObjectWithMetadata', isGift: string | null, giftFrom: string | null, giftMessage: string | null };

export type OrderAppProductVariantBusinessDetailsFragment = { __typename?: 'ProductVariant', variantCTA: OrderAppCtaType, quantityAvailable: number, sku: string, phoneCTA: OrderAppCtaType, webSellable: boolean | null };

export type OrderAppOrderAppCheckoutCreateMutationVariables = Exact<{
  channelSlug: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrderAppOrderAppCheckoutCreateMutation = { __typename?: 'Mutation', checkoutCreate: { __typename?: 'CheckoutCreate', checkout: { __typename?: 'CheckoutCreateCheckout', id: string, email: string | null, user: { __typename?: 'CheckoutCreateUser', email: string | null } | null } | null, errors: Array<{ __typename?: 'Error', field: string, code: string, context: string | null, message: string }> } | null };

export type OrderAppOrderAppCheckoutDeliveryModeUpdateMutationVariables = Exact<{
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  deliveryMode: OrderAppDeliveryMode;
  boutiqueExtReference?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<OrderAppAddressInput>;
}>;


export type OrderAppOrderAppCheckoutDeliveryModeUpdateMutation = { __typename?: 'Mutation', deliveryModeUpdate: { __typename?: 'DeliveryModeUpdateResult', errors: Array<{ __typename?: 'Error', field: string, code: string, message: string }> } };

export type OrderAppOrderAppCheckoutGwpUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  checkoutGwp: OrderAppCheckoutGwpInput;
}>;


export type OrderAppOrderAppCheckoutGwpUpdateMutation = { __typename?: 'Mutation', gwpCheckoutUpdate: { __typename?: 'CheckoutGwpUpdateResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context: string | null, message: string }> } };

export type OrderAppOrderAppCheckoutLineBraceletSizeUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  braceletSize: Scalars['String']['input'];
}>;


export type OrderAppOrderAppCheckoutLineBraceletSizeUpdateMutation = { __typename?: 'Mutation', updateMetadata: { __typename?: 'UpdateMetadataResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context: string | null, message: string }>, item: { __typename?: 'ObjectWithMetadata', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null } };

export type OrderAppOrderAppCheckoutLinesAddMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  lines: Array<OrderAppCheckoutLineInput> | OrderAppCheckoutLineInput;
}>;


export type OrderAppOrderAppCheckoutLinesAddMutation = { __typename?: 'Mutation', checkoutLinesAdd: { __typename?: 'CheckoutLinesAddResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context: string | null, message: string }> } };

export type OrderAppOrderAppCheckoutLinesDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  linesIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type OrderAppOrderAppCheckoutLinesDeleteMutation = { __typename?: 'Mutation', checkoutLinesDelete: { __typename?: 'CheckoutLinesDeleteResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context: string | null, message: string }> } };

export type OrderAppOrderAppCheckoutShippingAddressUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  address: OrderAppAddressInput;
  validationRules?: InputMaybe<OrderAppCheckoutAddressValidationRules>;
}>;


export type OrderAppOrderAppCheckoutShippingAddressUpdateMutation = { __typename?: 'Mutation', checkoutShippingAddressUpdate: { __typename?: 'CheckoutShippingAddressUpdateResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context: string | null, message: string }> } };

export type OrderAppOrderAppCheckoutVoucherAddMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  code: Scalars['String']['input'];
}>;


export type OrderAppOrderAppCheckoutVoucherAddMutation = { __typename?: 'Mutation', checkoutVoucherAdd: { __typename?: 'CheckoutVoucherAddResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context: string | null, message: string }> } };

export type OrderAppOrderAppCheckoutVoucherDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrderAppOrderAppCheckoutVoucherDeleteMutation = { __typename?: 'Mutation', checkoutVoucherDelete: { __typename?: 'CheckoutVoucherDeleteResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context: string | null, message: string }> } };

export type OrderAppGiftMetadataDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrderAppGiftMetadataDeleteMutation = { __typename?: 'Mutation', deleteMetadata: { __typename?: 'DeleteMetadata', errors: Array<{ __typename?: 'Error', field: string, code: string, context: string | null, message: string }>, item: { __typename?: 'ObjectWithMetadata', isGift: string | null, giftFrom: string | null, giftMessage: string | null } | null } };

export type OrderAppGiftMetadataUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  giftFrom: Scalars['String']['input'];
  giftMessage: Scalars['String']['input'];
}>;


export type OrderAppGiftMetadataUpdateMutation = { __typename?: 'Mutation', updateMetadata: { __typename?: 'UpdateMetadataResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context: string | null, message: string }>, item: { __typename?: 'ObjectWithMetadata', isGift: string | null, giftFrom: string | null, giftMessage: string | null } | null } };

export type OrderAppOfflinePaymentToggleMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type OrderAppOfflinePaymentToggleMutation = { __typename?: 'Mutation', offlinePaymentToggle: { __typename?: 'OfflinePaymentToggleResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context: string | null, message: string }> } };

export type OrderAppOrderAbandonMutationVariables = Exact<{
  checkoutId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
}>;


export type OrderAppOrderAbandonMutation = { __typename?: 'Mutation', orderAbandon: { __typename?: 'OrderAbandonResult', newBusinessId: string | null, errors: Array<{ __typename?: 'Error', field: string, code: string, context: string | null, message: string }> } };

export type OrderAppOrderAppOrderCreateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrderAppOrderAppOrderCreateMutation = { __typename?: 'Mutation', orderCreate: { __typename?: 'OrderCreateResult', order: { __typename?: 'Order', id: string, businessId: string } | null, errors: Array<{ __typename?: 'Error', field: string, code: string, context: string | null, message: string }> } };

export type OrderAppOrderAppOrderGwpUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  orderGwp: OrderAppOrderGwpInput;
}>;


export type OrderAppOrderAppOrderGwpUpdateMutation = { __typename?: 'Mutation', gwpOrderUpdate: { __typename?: 'OrderGwpUpdateResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context: string | null, message: string }> } };

export type OrderAppOrderPayPerLinkTokenCreateMutationVariables = Exact<{
  invitationMethod: OrderAppInvitationMethod;
  id: Scalars['ID']['input'];
}>;


export type OrderAppOrderPayPerLinkTokenCreateMutation = { __typename?: 'Mutation', orderSendPaymentInvitation: { __typename?: 'OrderSendPaymentInvitationResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context: string | null, message: string }> } };

export type OrderAppOrderAppOrderShippingAddressUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  address: OrderAppAddressInput;
}>;


export type OrderAppOrderAppOrderShippingAddressUpdateMutation = { __typename?: 'Mutation', orderShippingAddressUpdate: { __typename?: 'OrderShippingAddressUpdateResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context: string | null, message: string }> } };

export type OrderAppUpdateMetadataMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: Array<OrderAppMetadataInput> | OrderAppMetadataInput;
}>;


export type OrderAppUpdateMetadataMutation = { __typename?: 'Mutation', updateMetadata: { __typename?: 'UpdateMetadataResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context: string | null, message: string }>, item: { __typename?: 'ObjectWithMetadata', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null } };

export type OrderAppWithdrawalSubmitMutationVariables = Exact<{
  input: OrderAppWithdrawalSubmitInput;
}>;


export type OrderAppWithdrawalSubmitMutation = { __typename?: 'Mutation', withdrawalSubmit: { __typename?: 'WithdrawalSubmitResult', withdrawalSubmit: { __typename?: 'WithdrawalSubmitInfo', code: OrderAppWithdrawalSubmitCode, withdrawalRequestId: string, submittedAt: string, items: Array<{ __typename?: 'WithdrawalSubmitLine', orderLineId: string, quantity: number, reasonCode: OrderAppOrderReturnReason | null, translatedReason: string | null, comment: string | null, status: string }> } | null, errors: Array<{ __typename?: 'Error', code: string, message: string, field: string, context: string | null }> } };

export type OrderAppOrderAppBillingCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderAppOrderAppBillingCountriesQuery = { __typename?: 'Query', billingCountries: Array<{ __typename?: 'BillingCountry', code: string | null, name: string | null }> };

export type OrderAppOrderAppCheckoutChannelConfigQueryVariables = Exact<{
  channel: Scalars['String']['input'];
}>;


export type OrderAppOrderAppCheckoutChannelConfigQuery = { __typename?: 'Query', channelConfig: { __typename?: 'ChannelConfig', deliveryModes: Array<OrderAppDeliveryMode> } | null };

export type OrderAppOrderAppGwpProductsQueryVariables = Exact<{
  checkout_id: Scalars['String']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
  thresh_hold?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrderAppOrderAppGwpProductsQuery = { __typename?: 'Query', gwpProducts: Array<{ __typename?: 'GwpProduct', slug: string, id: string, name: string, available_quantity: number, product_type_slug: string, threshhold: string, thumbnail_alt: string | null, thumbnail_url: string | null }> | null };

export type OrderAppOrderAppOfflinePaymentAvailabilityQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrderAppOrderAppOfflinePaymentAvailabilityQuery = { __typename?: 'Query', storefrontOfflinePaymentAvailability: boolean };

export type OrderAppOrderAppOrderByPaymentTokenQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type OrderAppOrderAppOrderByPaymentTokenQuery = { __typename?: 'Query', orderByPaymentToken: { __typename?: 'PayPerLinkOrder', id: string, expirationTimestamp: number } | null };

export type OrderAppOrderAppGetOrderExtraDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrderAppOrderAppGetOrderExtraDataQuery = { __typename?: 'Query', order: { __typename?: 'Order', id: string, businessId: string } | null };

export type OrderAppProductVariantBusinessDetailsQueryVariables = Exact<{
  sku: Scalars['String']['input'];
  channel: Scalars['String']['input'];
}>;


export type OrderAppProductVariantBusinessDetailsQuery = { __typename?: 'Query', productVariant: { __typename?: 'ProductVariant', variantCTA: OrderAppCtaType, quantityAvailable: number, sku: string, phoneCTA: OrderAppCtaType, webSellable: boolean | null } | null };

export type OrderAppProductVariantsBusinessDetailsQueryVariables = Exact<{
  skus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  channel: Scalars['String']['input'];
}>;


export type OrderAppProductVariantsBusinessDetailsQuery = { __typename?: 'Query', productVariants: Array<{ __typename?: 'ProductVariant', variantCTA: OrderAppCtaType, quantityAvailable: number, sku: string, phoneCTA: OrderAppCtaType, webSellable: boolean | null }> | null };

export type OrderAppReturnReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderAppReturnReasonsQuery = { __typename?: 'Query', returnReasons: Array<{ __typename?: 'ReturnReason', id: string, audiences: Array<OrderAppReturnReasonAudience>, translations: Array<{ __typename?: 'ReturnReasonTranslation', languageCode: string, value: string }> }> };

export type OrderAppOrderAppValidateOrderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrderAppOrderAppValidateOrderQuery = { __typename?: 'Query', validateOrder: { __typename?: 'OrderValidationResult', id: string, valid: boolean, errors: Array<{ __typename?: 'Error', field: string, code: string, context: string | null, message: string }> } };

export type OrderAppOrderAppGetVoucherQueryVariables = Exact<{
  code: Scalars['String']['input'];
  channel: Scalars['String']['input'];
}>;


export type OrderAppOrderAppGetVoucherQuery = { __typename?: 'Query', voucher: { __typename?: 'VoucherObject', type: string, discountValueType: string } | null };

export type OrderAppWithdrawalEligibilityQueryVariables = Exact<{
  input: OrderAppWithdrawalEligibilityInput;
}>;


export type OrderAppWithdrawalEligibilityQuery = { __typename?: 'Query', withdrawalEligibility: { __typename?: 'WithdrawalEligibilityResult', withdrawal: { __typename?: 'WithdrawalInfo', code: OrderAppWithdrawalEligibilityCode, accessMode: OrderAppWithdrawalAccessMode, customer: { __typename?: 'WithdrawalCustomer', email: string, firstName: string | null, lastName: string | null }, order: { __typename?: 'WithdrawalOrderSummary', id: string, businessId: string, status: string, createdAt: string | null, channel: string | null }, lines: Array<{ __typename?: 'WithdrawalLine', orderLineId: string, productName: string, sku: string, quantity: number, eligibleQuantity: number, status: OrderAppWithdrawalLineStatus, disabledReasonCode: OrderAppDisabledReasonCode | null, referenceDate: string | null, referenceDateSource: OrderAppReferenceDateSource | null, windowEndAt: string | null }> } | null, errors: Array<{ __typename?: 'Error', code: string, message: string }> } };

export const OrderAppBillingCountryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAppBillingCountry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingCountry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<OrderAppOrderAppBillingCountryFragment, unknown>;
export const OrderAppErrorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAppError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<OrderAppOrderAppErrorFragment, unknown>;
export const GiftMetadataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GiftMetadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectWithMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"isGift"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftFrom"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_from","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftMessage"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_message","block":false}}]}]}}]} as unknown as DocumentNode<OrderAppGiftMetadataFragment, unknown>;
export const ProductVariantBusinessDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantBusinessDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variantCTA"}},{"kind":"Field","alias":{"kind":"Name","value":"phoneCTA"},"name":{"kind":"Name","value":"variantCTA"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fromCPI"},"value":{"kind":"BooleanValue","value":false}},{"kind":"Argument","name":{"kind":"Name","value":"sellingType"},"value":{"kind":"EnumValue","value":"PHONE"}}]},{"kind":"Field","name":{"kind":"Name","value":"quantityAvailable"}},{"kind":"Field","alias":{"kind":"Name","value":"webSellable"},"name":{"kind":"Name","value":"sellable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sellingType"},"value":{"kind":"EnumValue","value":"WEB"}}]},{"kind":"Field","name":{"kind":"Name","value":"sku"}}]}}]} as unknown as DocumentNode<OrderAppProductVariantBusinessDetailsFragment, unknown>;
export const OrderAppCheckoutCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderAppCheckoutCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brand"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelSlug"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"brand"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brand"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAppError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAppError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<OrderAppOrderAppCheckoutCreateMutation, OrderAppOrderAppCheckoutCreateMutationVariables>;
export const OrderAppCheckoutDeliveryModeUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderAppCheckoutDeliveryModeUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"checkoutId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deliveryMode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryMode"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boutiqueExtReference"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryModeUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"checkoutId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"checkoutId"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"deliveryMode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deliveryMode"}}},{"kind":"Argument","name":{"kind":"Name","value":"boutiqueExtReference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boutiqueExtReference"}}},{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<OrderAppOrderAppCheckoutDeliveryModeUpdateMutation, OrderAppOrderAppCheckoutDeliveryModeUpdateMutationVariables>;
export const OrderAppCheckoutGwpUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderAppCheckoutGwpUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"checkoutGwp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutGwpInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gwpCheckoutUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"checkoutGwp"},"value":{"kind":"Variable","name":{"kind":"Name","value":"checkoutGwp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAppError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAppError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<OrderAppOrderAppCheckoutGwpUpdateMutation, OrderAppOrderAppCheckoutGwpUpdateMutationVariables>;
export const OrderAppCheckoutLineBraceletSizeUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderAppCheckoutLineBraceletSizeUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"braceletSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"relatedBraceletSize","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"braceletSize"}}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAppError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAppError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<OrderAppOrderAppCheckoutLineBraceletSizeUpdateMutation, OrderAppOrderAppCheckoutLineBraceletSizeUpdateMutationVariables>;
export const OrderAppCheckoutLinesAddDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderAppCheckoutLinesAdd"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lines"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutLineInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutLinesAdd"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"lines"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lines"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAppError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAppError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<OrderAppOrderAppCheckoutLinesAddMutation, OrderAppOrderAppCheckoutLinesAddMutationVariables>;
export const OrderAppCheckoutLinesDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderAppCheckoutLinesDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"linesIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutLinesDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"linesIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"linesIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAppError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAppError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<OrderAppOrderAppCheckoutLinesDeleteMutation, OrderAppOrderAppCheckoutLinesDeleteMutationVariables>;
export const OrderAppCheckoutShippingAddressUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderAppCheckoutShippingAddressUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validationRules"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutAddressValidationRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutShippingAddressUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"shippingAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"Argument","name":{"kind":"Name","value":"validationRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validationRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAppError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAppError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<OrderAppOrderAppCheckoutShippingAddressUpdateMutation, OrderAppOrderAppCheckoutShippingAddressUpdateMutationVariables>;
export const OrderAppCheckoutVoucherAddDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderAppCheckoutVoucherAdd"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutVoucherAdd"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAppError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAppError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<OrderAppOrderAppCheckoutVoucherAddMutation, OrderAppOrderAppCheckoutVoucherAddMutationVariables>;
export const OrderAppCheckoutVoucherDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderAppCheckoutVoucherDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutVoucherDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAppError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAppError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<OrderAppOrderAppCheckoutVoucherDeleteMutation, OrderAppOrderAppCheckoutVoucherDeleteMutationVariables>;
export const GiftMetadataDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GiftMetadataDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"keys"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"gift","block":false},{"kind":"StringValue","value":"gift_from","block":false},{"kind":"StringValue","value":"gift_message","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAppError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GiftMetadata"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAppError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GiftMetadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectWithMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"isGift"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftFrom"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_from","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftMessage"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_message","block":false}}]}]}}]} as unknown as DocumentNode<OrderAppGiftMetadataDeleteMutation, OrderAppGiftMetadataDeleteMutationVariables>;
export const GiftMetadataUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GiftMetadataUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"giftFrom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"giftMessage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"StringValue","value":"true","block":false}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_from","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"giftFrom"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_message","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"giftMessage"}}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAppError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GiftMetadata"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAppError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GiftMetadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectWithMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"isGift"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftFrom"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_from","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftMessage"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_message","block":false}}]}]}}]} as unknown as DocumentNode<OrderAppGiftMetadataUpdateMutation, OrderAppGiftMetadataUpdateMutationVariables>;
export const OfflinePaymentToggleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OfflinePaymentToggle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offlinePaymentToggle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"isOfflinePayment"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAppError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAppError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<OrderAppOfflinePaymentToggleMutation, OrderAppOfflinePaymentToggleMutationVariables>;
export const OrderAbandonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderAbandon"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"checkoutId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderAbandon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"checkoutId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"checkoutId"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newBusinessId"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAppError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAppError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<OrderAppOrderAbandonMutation, OrderAppOrderAbandonMutationVariables>;
export const OrderAppOrderCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderAppOrderCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"businessId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAppError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAppError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<OrderAppOrderAppOrderCreateMutation, OrderAppOrderAppOrderCreateMutationVariables>;
export const OrderAppOrderGwpUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderAppOrderGwpUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderGwp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderGwpInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gwpOrderUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderGwp"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderGwp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAppError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAppError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<OrderAppOrderAppOrderGwpUpdateMutation, OrderAppOrderAppOrderGwpUpdateMutationVariables>;
export const OrderPayPerLinkTokenCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderPayPerLinkTokenCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitationMethod"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InvitationMethod"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderSendPaymentInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"invitationMethod"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitationMethod"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAppError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAppError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<OrderAppOrderPayPerLinkTokenCreateMutation, OrderAppOrderPayPerLinkTokenCreateMutationVariables>;
export const OrderAppOrderShippingAddressUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderAppOrderShippingAddressUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderShippingAddressUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"shippingAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAppError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAppError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<OrderAppOrderAppOrderShippingAddressUpdateMutation, OrderAppOrderAppOrderShippingAddressUpdateMutationVariables>;
export const UpdateMetadataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMetadata"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MetadataInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAppError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAppError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<OrderAppUpdateMetadataMutation, OrderAppUpdateMetadataMutationVariables>;
export const WithdrawalSubmitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"WithdrawalSubmit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WithdrawalSubmitInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"withdrawalSubmit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"withdrawalSubmit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"withdrawalRequestId"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderLineId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"reasonCode"}},{"kind":"Field","name":{"kind":"Name","value":"translatedReason"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"context"}}]}}]}}]}}]} as unknown as DocumentNode<OrderAppWithdrawalSubmitMutation, OrderAppWithdrawalSubmitMutationVariables>;
export const OrderAppBillingCountriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderAppBillingCountries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingCountries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAppBillingCountry"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAppBillingCountry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingCountry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<OrderAppOrderAppBillingCountriesQuery, OrderAppOrderAppBillingCountriesQueryVariables>;
export const OrderAppCheckoutChannelConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderAppCheckoutChannelConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryModes"}}]}}]}}]} as unknown as DocumentNode<OrderAppOrderAppCheckoutChannelConfigQuery, OrderAppOrderAppCheckoutChannelConfigQueryVariables>;
export const OrderAppGwpProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderAppGwpProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"checkout_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thresh_hold"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brand"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gwpProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"checkout_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"checkout_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}},{"kind":"Argument","name":{"kind":"Name","value":"thresh_hold"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thresh_hold"}}},{"kind":"Argument","name":{"kind":"Name","value":"brand"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brand"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"available_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"product_type_slug"}},{"kind":"Field","name":{"kind":"Name","value":"threshhold"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_alt"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_url"}}]}}]}}]} as unknown as DocumentNode<OrderAppOrderAppGwpProductsQuery, OrderAppOrderAppGwpProductsQueryVariables>;
export const OrderAppOfflinePaymentAvailabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderAppOfflinePaymentAvailability"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storefrontOfflinePaymentAvailability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<OrderAppOrderAppOfflinePaymentAvailabilityQuery, OrderAppOrderAppOfflinePaymentAvailabilityQueryVariables>;
export const OrderAppOrderByPaymentTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderAppOrderByPaymentToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderByPaymentToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"expirationTimestamp"}}]}}]}}]} as unknown as DocumentNode<OrderAppOrderAppOrderByPaymentTokenQuery, OrderAppOrderAppOrderByPaymentTokenQueryVariables>;
export const OrderAppGetOrderExtraDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderAppGetOrderExtraData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"businessId"}}]}}]}}]} as unknown as DocumentNode<OrderAppOrderAppGetOrderExtraDataQuery, OrderAppOrderAppGetOrderExtraDataQueryVariables>;
export const ProductVariantBusinessDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductVariantBusinessDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sku"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sku"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sku"}}},{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantBusinessDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantBusinessDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variantCTA"}},{"kind":"Field","alias":{"kind":"Name","value":"phoneCTA"},"name":{"kind":"Name","value":"variantCTA"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fromCPI"},"value":{"kind":"BooleanValue","value":false}},{"kind":"Argument","name":{"kind":"Name","value":"sellingType"},"value":{"kind":"EnumValue","value":"PHONE"}}]},{"kind":"Field","name":{"kind":"Name","value":"quantityAvailable"}},{"kind":"Field","alias":{"kind":"Name","value":"webSellable"},"name":{"kind":"Name","value":"sellable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sellingType"},"value":{"kind":"EnumValue","value":"WEB"}}]},{"kind":"Field","name":{"kind":"Name","value":"sku"}}]}}]} as unknown as DocumentNode<OrderAppProductVariantBusinessDetailsQuery, OrderAppProductVariantBusinessDetailsQueryVariables>;
export const ProductVariantsBusinessDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductVariantsBusinessDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skus"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productVariants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skus"}}},{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantBusinessDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantBusinessDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variantCTA"}},{"kind":"Field","alias":{"kind":"Name","value":"phoneCTA"},"name":{"kind":"Name","value":"variantCTA"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fromCPI"},"value":{"kind":"BooleanValue","value":false}},{"kind":"Argument","name":{"kind":"Name","value":"sellingType"},"value":{"kind":"EnumValue","value":"PHONE"}}]},{"kind":"Field","name":{"kind":"Name","value":"quantityAvailable"}},{"kind":"Field","alias":{"kind":"Name","value":"webSellable"},"name":{"kind":"Name","value":"sellable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sellingType"},"value":{"kind":"EnumValue","value":"WEB"}}]},{"kind":"Field","name":{"kind":"Name","value":"sku"}}]}}]} as unknown as DocumentNode<OrderAppProductVariantsBusinessDetailsQuery, OrderAppProductVariantsBusinessDetailsQueryVariables>;
export const ReturnReasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReturnReasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returnReasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"audiences"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"languageCode"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<OrderAppReturnReasonsQuery, OrderAppReturnReasonsQueryVariables>;
export const OrderAppValidateOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderAppValidateOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"valid"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAppError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAppError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<OrderAppOrderAppValidateOrderQuery, OrderAppOrderAppValidateOrderQueryVariables>;
export const OrderAppGetVoucherDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderAppGetVoucher"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voucher"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"discountValueType"}}]}}]}}]} as unknown as DocumentNode<OrderAppOrderAppGetVoucherQuery, OrderAppOrderAppGetVoucherQueryVariables>;
export const WithdrawalEligibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WithdrawalEligibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WithdrawalEligibilityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"withdrawalEligibility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"withdrawal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"accessMode"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"businessId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderLineId"}},{"kind":"Field","name":{"kind":"Name","value":"productName"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"eligibleQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"disabledReasonCode"}},{"kind":"Field","name":{"kind":"Name","value":"referenceDate"}},{"kind":"Field","name":{"kind":"Name","value":"referenceDateSource"}},{"kind":"Field","name":{"kind":"Name","value":"windowEndAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<OrderAppWithdrawalEligibilityQuery, OrderAppWithdrawalEligibilityQueryVariables>;